import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { preloadRoute } from "@/prerenderedRoutes";

const root = ReactDOM.createRoot(document.getElementById("root"));
// The route's code first, so a prerendered page is replaced by the same page and
// never by a loading fallback. See prerenderedRoutes.js.
preloadRoute(window.location.pathname).then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
